import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from './locales/ru.json';
import en from './locales/en.json';

// Get language from cookie or localStorage
const getStoredLanguage = () => {
  // Check cookie first (set by launcher)
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'preferred_language') {
      return value;
    }
  }
  // Fallback to localStorage
  return localStorage.getItem('language') || 'ru';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['localStorage', 'cookie'],
      cookieMinutes: 525600, // 1 year
      lookupCookie: 'preferred_language',
      lookupLocalStorage: 'language',
    },
  });

// Function to change language and sync with launcher
export const changeLanguage = async (lang) => {
  await i18n.changeLanguage(lang);
  localStorage.setItem('language', lang);

  // Set cookie for launcher sync
  document.cookie = `preferred_language=${lang}; path=/; max-age=31536000; SameSite=Lax`;

  // Try to sync with launcher API
  try {
    const token = localStorage.getItem('session_token');
    if (token) {
      await fetch('/api/user/language', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ language: lang }),
      });
    }
  } catch (e) {
    // Silently fail - cookie will still work
    console.log('Could not sync language with launcher');
  }
};

export default i18n;
